// surf_utopia — T2, 4 stages, noite estrelada. Recriação livre do icônico de
// CS:S: rampas GIGANTES, curva de 90°, transferência dupla com ATALHO central.
import { Course } from '../course';
import type { GameMap } from '../types';
import { finishMap } from './util';

export function buildUtopia(): GameMap {
  const c = new Course(0, 0, 256, 0);

  // === Stage 1: a descida gigante ===
  c.spawnHere(-256);
  c.zoneOver(c.platform(256, 512), 'start');
  c.drop(688);
  c.ramp(768, 640, 5200);
  c.drop(16);
  c.spawnHere(-256);
  c.zoneOver(c.platform(512, 768), 'stage', { index: 2 });

  // === Stage 2: curva de 90° em segmentos ===
  c.drop(688);
  c.ramp(768, 640, 2000);
  c.turn(-30);
  c.ramp(768, 640, 1600);
  c.turn(-30);
  c.ramp(768, 640, 1600);
  c.turn(-30);
  c.ramp(768, 640, 2000);
  c.drop(16);
  c.spawnHere(-256);
  c.zoneOver(c.platform(512, 768), 'stage', { index: 3 });

  // === Stage 3: transferência dupla + ATALHO central roxo ===
  c.drop(688);
  c.mark();
  c.shift(0); // atalho: lane central estreita e contínua
  c.ramp(320, 640, 5000, 'short');
  c.restore();
  c.shift(-640);
  c.ramp(704, 640, 2200);
  c.shift(1280);
  c.advance(300);
  c.ramp(704, 640, 2200);
  c.shift(-640);
  c.advance(300);
  c.drop(16);
  c.spawnHere(-256);
  c.zoneOver(c.platform(1152, 768), 'stage', { index: 4 });

  // === Stage 4: reta final colossal ===
  c.drop(688);
  c.ramp(832, 640, 4800);
  c.drop(16);
  c.zoneOver(c.platform(960, 832, 'accent'), 'end');

  return finishMap(c, 'surf_utopia');
}
